// ZoomSession.js
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useUserContext } from "../../Contexts/UserContext";
import ZoomVideo from "@zoom/videosdk";
import "@zoom/videosdk-ui-toolkit/dist/videosdk-ui-toolkit.css";
import "../app/App.css";
import { toast } from "react-toastify";
import MediaContext from "../../Contexts/media-context"; // Import the MediaContext
import ZoomContext from "../../Contexts/zoom-context";
import VideoContainer from "./Video"; // Import the VideoContainer
import { MediaStream, ZoomClient } from "@/src/index-types";
import Button from "../form-components/input/Button";

const ExternalZoomSession: React.FC = () => {
	const { id } = useParams<{ id: string }>();
	const caseId = id;
	const authToken = sessionStorage.getItem("token");
	const { title } = useParams<{ title: string }>();
	const { email } = useParams<{ email: string }>();
	const sessionName = title;
	const { userData } = useUserContext();
	const [status, setStatus] = useState("idle");
	const [isSessionActive, setIsSessionActive] = useState(false);
	const mediaStream = useRef<MediaStream | null>(null);
	const videoClient = useRef<ZoomClient | null>(null);
	const [sessionParams, setSessionParams] = useState({
		sessionName: null,
		JWT: null,
		userName: null,
	});

	const authEndpoint =
		"https://backend-kyw8.onrender.com/session/external/join";

	const getVideoSDKJWT = async () => {
		try {
			setStatus("loading");

			const response = await fetch(authEndpoint, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${authToken}`,
				},
				body: JSON.stringify({ caseId, email }),
			});

			const data = await response.json();

			if (!response.ok) {
				toast.error(
					data.message ??
						"An unexpected error occurred. Please try again later.",
					{
						position: "bottom-right",
					}
				);
				throw new Error(data.message ?? "An error occurred");
			}

			if (data.token) {
				setSessionParams((prev) => ({
					...prev,
					userName: data.userName,
					sessionName: data.sessionName,
					JWT: data.token,
				}));
			}
		} catch (error) {
			setStatus("fail");
		}
	};

	const init = async ({ sessionName, JWT, userName }) => {
		try {
			videoClient.current = ZoomVideo.createClient();

			await videoClient.current.init("US-EN", "CDN", {
				enforceMultipleVideos: true,
				enforceVirtualBackground: true,
			});
			await videoClient.current.join(sessionName, JWT, userName);

			const stream = videoClient.current.getMediaStream();
			mediaStream.current = stream;
			console.log(mediaStream);
			setStatus("success");
			setIsSessionActive(true);
		} catch (error) {
			console.log("Error joining session", error);
		}
	};
	useEffect(() => {
		const canProceed = Object.keys(sessionParams).every(
			(key) => sessionParams[key] !== null
		);

		console.log(canProceed, sessionParams);

		if (canProceed) {
			init(sessionParams);
		}
	}, [sessionParams]);

	return (
		<div className="main-div">
			<MediaContext.Provider value={mediaStream.current}>
				{" "}
				{/* Provide the media stream */}
				<ZoomContext.Provider value={videoClient.current}>
					{!isSessionActive && (
						<div
							id="join-flow"
							className="form-div !max-w-fit flex flex-col gap-6 border border-[#222222] rounded-[20px]">
							<div>
								<h1>Join session for {sessionName}</h1>
								<Button
									onClick={getVideoSDKJWT}
									buttonText="Join Session"
									isLoading={status === "loading"}
									disabled={status === "loading"}
								/>
							</div>
						</div>
					)}
					{/* VideoContainer is added here */}

					{isSessionActive && (
						<VideoContainer
							currentUserRole={userData.userRole}
							setIsSessionActive={setIsSessionActive}
							isSessionActive={isSessionActive}
							sessionName={sessionName}
						/>
					)}
				</ZoomContext.Provider>
			</MediaContext.Provider>
		</div>
	);
};

export default ExternalZoomSession;
